import styled from 'styled-components';

const PrdStickers = styled.p`
  margin: 0 0 15px;

  img {
    display: inline-block;
    margin: 0 10px 5px 0;
  }

  .resultList & {
    margin-bottom: 10px;
    @media ${({ theme }) => theme.breakpoints.mobile} {
      text-align: center;
    }

    img {
      margin-top: 0;
      margin-right: 0;
      max-width: 100%;
      @media ${({ theme }) => theme.breakpoints.tablet} {
        margin-top: 8px;
        margin-bottom: 8px;
      }
    }
  }

  .resultGrid & {
    margin: 0 0 10px;

    img {
      max-width: 100%;
      margin: 2px 0;
    }
  }
`;

export default PrdStickers;
